export const announcementsData = [
    {
      key: "1",
      DATE: "29 Nov 2024",
      TIME: "01:00 PM",
      ANNOUNCEMENT: "Exciting News!",
      CONTENT: "We are now offering premium car rentals in your city!",
      TYPE: "New Rental Service",
      STATUS: "Published",
    },
    {
      key: "2",
      DATE: "03 Nov 2024",
      TIME: "10:00 AM",
      ANNOUNCEMENT: "Limited-Time Offer!",
      CONTENT: "Get 20% off on all weekend rentals. Book now and hit the road for less!",
      TYPE: "Special Offer",
      STATUS: "Unpublish",
    },
    {
      key: "3",
      DATE: "31 Oct 2024",
      TIME: "08:30 AM",
      ANNOUNCEMENT: "New Arrivals!",
      CONTENT: "We've added luxury SUVs and electric vehicles to our fleet.",
      TYPE: "New Vehicle Addition",
      STATUS: "Published",
    },
    {
      key: "4",
      DATE: "15 Oct 2024",
      TIME: "03:15 PM",
      ANNOUNCEMENT: "Holiday Special!",
      CONTENT: "Rent a car for 3 days and get the 4th day free this festive season.",
      TYPE: "Seasonal Promotion",
      STATUS: "Published",
    },
    {
      key: "5",
      DATE: "26 Sep 2024",
      TIME: "04:10 PM",
      ANNOUNCEMENT: "Important Update!",
      CONTENT: "Our rental deposit policy has changed.",
      TYPE: "Policy Update",
      STATUS: "Published",
    },
    {
      key: "6",
      DATE: "01 Sep 2024",
      TIME: "11:00 AM",
      ANNOUNCEMENT: "We've Expanded!",
      CONTENT: "Now serving customers at our brand-new Downtown Rental Center.",
      TYPE: "Branch Opening",
      STATUS: "Unpublish",
    },
    {
      key: "7",
      DATE: "15 Aug 2024",
      TIME: "09:40 AM",
      ANNOUNCEMENT: "Your Safety Matters!",
      CONTENT: "We ensure all rental cars are maintained for a worry-free journey.",
      TYPE: "Customer Safety",
      STATUS: "Unpublish",
    },
    {
      key: "8",
      DATE: "24 Jan 2025",
      TIME: "02:30 PM",
      ANNOUNCEMENT: "Introducing Our Rewards Program!",
      CONTENT: "Earn points every time you rent and redeem them for discounts.",
      TYPE: "Loyalty Program",
      STATUS: "Published",
    },
    {
      key: "9",
      DATE: "19 Dec 2024",
      TIME: "05:20 PM",
      ANNOUNCEMENT: "Temporary Closure Alert!",
      CONTENT:
        "Due to weather conditions, our rental office will be closed on 20 Jan 2025.",
      TYPE: "Emergency Closure",
      STATUS: "Published",
    },
    {
      key: "10",
      DATE: "11 Dec 2024",
      TIME: "09:30 AM",
      ANNOUNCEMENT: "Easier Than Ever!",
      CONTENT: "Our new website now lets you book your rentals in just a few clicks!",
      TYPE: "Online Booking Update",
      STATUS: "Published",
    },
];